import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const VideoPlaylistLoadable = loadable(() => import('./VideoPlaylist'), {
  resolveComponent: components => components.VideoPlaylist
});

export const VideoPlaylist = WithLazyHydration(VideoPlaylistLoadable, {
  name: 'VideoPlaylist'
});
